module.exports = __webpack_public_path__ + "static/media/9.7a5721d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/9.jpg
// module id = 542
// module chunks = 0